/**
 *  Created by Rowan de Zeeuw on 07/09/2018. Used source code from
 *  Backbase CXPContentWidget to create this extendable version.
 *
 *  ----------------------------------------------------------------
 *  Author : Backbase R&D - Amsterdam - New York
 *  Filename : content.js
 *  Description:
 *
 *  Source code for CXP Universal Content Widget
 *  ----------------------------------------------------------------
 */
import AbstractWidgetBaseController from '../base/controller';

const bd = window.bd; /* eslint-disable-line no-unused-vars */
const be = window.be; /* eslint-disable-line no-unused-vars */
const $ = window.jQuery;

class AbstractIceContentController extends AbstractWidgetBaseController {
    constructor(widget) {
        super(widget);
        //if (be.ice && bd && bd.designMode == 'true') {
        !window.__TEST__ && this.renderIceWidget();
        //}
    }

    renderIceWidget() {
        if (!be.ice) {
            $('img[src=""], img:not([src])', this.widget.body).addClass('be-ice-hide-image');
            $(this.widget.body).addClass('be-ice-widget-rendered');
            return;
        }
        this.widget.iceConfig = be.ice.config;

        if (this.cxpWidget.canEditContent()) {
            this.cxpWidget.prepareCxpPreferences();

            let templateUrl = String(this.widget.getPreference('templateUrl'));

            const enableEditing = () => {
                // it is possible to swap template for editorial
                // here is an example for image template
                if (templateUrl.match(/\/image\.html$/)) {
                    templateUrl = templateUrl.replace(/\/image\.html$/, '/image-editorial.html');
                }

                return be.ice.controller.edit(this.widget, templateUrl).then(dom => {
                    $(this.widget.body)
                        .find('.bp-g-include')
                        .html(dom.dom);
                    return dom.dom;
                });
            };

            // this widget has property rendering example (template: simple.html)
            // so we need to refresh widget after property 'title' modified
            this.widget.model.addEventListener(
                'PrefModified',
                oEvent => {
                    if (oEvent.attrName === 'title') {
                        enableEditing();
                    }
                },
                false,
                this.widget
            );

            enableEditing();
        } else {
            $(this.widget.body).addClass('be-ice-widget-rendered');
        }
    }
}

export default AbstractIceContentController;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/abstract/ice-content/controller.js